/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface PageResponseFamille {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export interface ValidateIncidentRequest {
  validate: boolean
  isPrioritaire: boolean

  /** @format uuid */
  prestataireId?: string
}

export interface IncidentBasicSocieteListResponse {
  societes: IncidentBasicSocieteResponse[]
  page: PageResponseIncident
}

export interface PlanUpdate {
  /** Parametrages d'affichage initial du plan. */
  viewerParams?: PlanViewerParams | null

  /** Le DXF encodé base 64 */
  dxfBase64?: string | null
}

export interface ControleQualiteResponse {
  /** @format uuid */
  id: string
  numero: number

  /** @format uuid */
  societeId: string

  /** @format uuid */
  metierId: string

  /** @format uuid */
  utilisateurId: string

  /** @format uuid */
  manifestationId?: string
  period?: ControleQualitePeriode
  tauxConformite: number
  nature: ControleQualiteNature
  type: ControleQualiteTypeControle
  commentaire?: string

  /** @format date-time */
  dateValidation: string
  reponses: ControleQualiteReponseResponse[]
}

export interface ManifestationResponse {
  /** @format uuid */
  id: string
  codeManifestation: string
  dateOuverturePublic: string
  dateFermeturePublic: string

  /** @format uuid */
  siteId: string
  dateDebutMontage: string
  dateFinDemontage: string
  libelle: string
  nomOrganisateur: string
  codeOrganisateur: string
  mailOrganisateur: string
  actif: boolean
  adresse1Organisateur?: string
  adresse2Organisateur?: string
  adresse3Organisateur?: string
  codePostalOrganisateur?: string
  villeOrganisateur?: string
  paysOrganisateur?: string
  espaceIds: string[]
}

export interface PlanViewerParams {
  /**
   * @min 1
   * @max 21
   */
  zoom?: number | null
  center?: PlanViewerParamsCenter | null
}

export interface EtatDesLieuxExportRequest {
  etatDesLieuxIds: string[]
}

export type LoginRefreshSuccessResponse = LoginSuccessBaseResponse

export interface UsersList {
  users: UserResponse[]
  page: PageResponseUsers
}

export interface CommandeListResponse {
  commandes: CommandeResponse[]
}

export interface StandInaccessibleRequest {
  commentaire: string
  filename?: string

  /** Contenu de la pièce jointe en DataURL (RFC 2397) */
  fileContent?: string
}

export interface ControleQualiteStatistiqueResponse {
  /**
   * Le taux de conformité moyen. Peut être null s'il n'y a aucun contrôle correspondant.
   * @format double
   */
  tauxConformiteMoyen?: number

  /** @format int64 */
  nombreControle: number

  /** @format int64 */
  nombreControleSansObservation: number

  /** @format int64 */
  nombreControleAvecObservation: number

  /** @format int64 */
  nombreControleNonConforme: number

  /** @format int64 */
  nombreSocietesAudite: number
}

export interface TokenRequest {
  token: string
}

export interface FamilleListResponse {
  familles: FamilleResponse[]
  page: PageResponseFamille
}

export interface UsersExportRequest {
  userIds: string[]
}

export interface CommandeNonConnecteListResponse {
  commandes: CommandeNonConnecteResponse[]
}

export enum ControleQualitePeriode {
  MONTAGE = 'MONTAGE',
  DEMONTAGE = 'DEMONTAGE',
  OUVERTURE_PUBLIC = 'OUVERTURE_PUBLIC',
}

export interface LocalisationListResponse {
  localisations: LocalisationResponse[]
  page: PageResponseLocalisation
}

export interface UploadImageIncidentRequest {
  filename: string

  /** Contenu de l'image au format RFC 2397 */
  image: string
}

export interface ControleQualiteCreationRequest {
  /** @format uuid */
  societeId: string

  /** @format uuid */
  metierId: string

  /** @format uuid */
  manifestationId?: string
  period?: ControleQualitePeriode
  nature: ControleQualiteNature
  type: ControleQualiteTypeControle

  /** True si le prestataire est présent, false sinon */
  accompagnementPrestataire: boolean
  commentaire?: string
  reponses: ControleQualiteCreationReponseRequest[]
}

export enum Langage {
  FR = 'FR',
  EN = 'EN',
}

export enum ControleQualiteConformite {
  CONFORME = 'CONFORME',
  NON_CONFORME_MINEUR = 'NON_CONFORME_MINEUR',
  NON_CONFORME_MAJEUR = 'NON_CONFORME_MAJEUR',
  NON_CONCERNE = 'NON_CONCERNE',
}

export interface SocieteResponse {
  /** @format uuid */
  id: string
  codeSociete: string
  nameSociete: string
  contact?: string
  phone?: string
  email?: string
  enabled: boolean
}

export interface ControleQualiteQuestionListResponse {
  questions: ControleQualiteQuestionResponse[]
}

export interface AffectationTechnicienIncidentRequest {
  /** @format uuid */
  technicienId: string
}

/**
 * Edl d'entrée ou de sortie
 */
export enum EtatDesLieuxTypeEnum {
  ENTREE = 'ENTREE',
  SORTIE = 'SORTIE',
}

export enum ControleQualiteTypeControle {
  VIPARIS = 'VIPARIS',
  AUTO = 'AUTO',
}

export interface ControleQualiteBasicSocieteResponse {
  /** @format uuid */
  id: string
  libelle: string
}

export interface LoginSsoResponse {
  url: string
  service_name: string
  url_referrer: string
}

export interface ControleQualiteHistoriqueListResponse {
  historique: ControleQualiteHistoriqueResponse[]
}

export interface ControleQualiteBasicLocalisationResponse {
  /** @format uuid */
  id: string
  libelle: string
}

export interface SocieteExportRequest {
  societeIds: string[]
}

/**
 * Infos des personnes qui devront recevoir les PDF au même titre que l'organisateur. Requiert soit l'id, soit l'email.
 */
export interface ContactEtatDesLieux {
  /** @format uuid */
  id?: string
  nom?: string
  prenom?: string
  email?: string
}

export interface ControleQualiteFiltreRequest {
  /** @format date */
  dateDebut?: string

  /** @format date */
  dateFin?: string
  siteIds?: string[]
  societeIds?: string[]
  manifestationIds?: string[]
  metierIds?: string[]
  espaceIds?: string[]
  type?: ControleQualiteTypeControle
  nature?: ControleQualiteNature

  /** true => avec observations / false => sans observation */
  observation?: boolean

  /** true => conforme / false => non conforme */
  conforme?: boolean
}

export interface PageResponseSite {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

/**
 * Liste des contacts de l'utilisateur
 */
export interface ContactListResponse {
  contacts?: Contact[]
  page?: PageResponseContacts
}

export interface EnvoieDevisIncidentRequest {
  filename?: string

  /** Contenu du devis en DataURL (RFC 2397) */
  fileContent?: string
  commentaire?: string
}

export interface PageResponsePreferenceNotification {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export interface ResetPasswordRequest {
  token: string
  password: string
}

export enum EtatWorkflowIncidentEnum {
  EN_ATTENTE_DE_VALIDATION = 'EN_ATTENTE_DE_VALIDATION',
  VALIDEE = 'VALIDEE',
  EN_ATTENTE_DE_PRISE_EN_CHARGE = 'EN_ATTENTE_DE_PRISE_EN_CHARGE',
  REFUS_PRESTATAIRE = 'REFUS_PRESTATAIRE',
  EN_COURS_DE_TRAITEMENT = 'EN_COURS_DE_TRAITEMENT',
  EN_PAUSE = 'EN_PAUSE',
  FERMEE = 'FERMEE',
  ABANDONNEE = 'ABANDONNEE',
  CLOTUREE_PRESTATAIRE = 'CLOTUREE_PRESTATAIRE',
  CLOTUREE_VIPARIS = 'CLOTUREE_VIPARIS',
  EN_ATTENTE_DE_DEVIS = 'EN_ATTENTE_DE_DEVIS',
  DEVIS_ENVOYE = 'DEVIS_ENVOYE',
}

export interface ControleQualiteCreationReponseRequest {
  /** @format uuid */
  questionId: string

  /** @format uuid */
  localisationId: string
  conformite: ControleQualiteConformite
  commentaire?: string
}

export interface UserBasicResponse {
  /** @format uuid */
  id: string
  nom: string
  prenom: string
  email?: string
  numeroTelephonePortable?: string
}

export interface CommandeIncident {
  numeroCommande?: string
  numeroLigne?: string
  isOrganisateur?: boolean
  referenceArticle?: string
  espace?: string
  allee?: string
  stand?: string
  enseigne?: string
  libelleFamille?: string
  libelleSousFamille?: string
  libelleArticle?: string
}

export interface PreferenceNotificationRequest {
  /** @format uuid */
  siteId?: string
  typeCanal?: TypeCanalEnum
  typeEvenement?: TypeEvenementEnum
  typeIncident?: TypeIncidentEnum
}

export interface RolesList {
  roles: RoleResponse[]
  page: PageResponseRoles
}

/**
 * Infos des personnes qui ont signées l'edl
 */
export interface ContactOrganisateurRequest {
  nom: string
  prenom: string
  email: string

  /** @format base64 */
  signatureBase64: string
}

export interface UserUpdateRequest {
  nom?: string
  prenom?: string
  numeroTelephone?: string
  fonction?: string
  langage?: Langage
}

export interface LocalisationResponse {
  /** @format uuid */
  id: string

  /** @format uuid */
  siteId: string
  code: string
  libelle: string

  /** @format uuid */
  parentId?: string
  viperId: string
  enabled: boolean

  /** Si 'true', cette localisation n'est pas vraiment une localisation mais un package */
  package?: boolean
}

export interface CreationIncidentRequest {
  /** @format uuid */
  siteId: string

  /** @format uuid */
  famillePrestationId: string

  /** @format uuid */
  manifestationId?: string

  /** @format uuid */
  localisationId?: string
  remonteDansEtatDesLieux?: boolean

  /** @format uuid */
  societePrestataireId?: string
  quantite?: number
  isPrioritaire?: boolean
  contactAssocie?: ContactIncident
  commandeAssociee?: CommandeIncident
  plan?: PositionPlanIncident
}

export interface PageResponsePlan {
  pageNumber: number
  pageSize: number
  totalPage: number
  totalElement: number
}

export interface PageResponseEtatDesLieux {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export interface RoleResponse {
  /** @format uuid */
  id: string
  name: string
  admin: boolean
  readOnly: boolean
  typeUtilisateur: TypeUtilisateurRole
  scopes: string[]
}

export interface PageResponseIncident {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export interface ControleQualiteBasicManifestationResponse {
  /** @format uuid */
  id: string
  libelle: string
}

export interface Plan {
  /** @format uuid */
  localisationId: string
  viewers: { geojson?: PlanViewer }
  status: 'absent' | 'pending' | 'ready' | 'error'
}

export interface ControleQualiteBasicLocalisationListResponse {
  localisations: ControleQualiteBasicLocalisationResponse[]
  page: ControleQualitePageResponse
}

export interface EtatDesLieuxListResponse {
  etatDesLieuxList: EtatDesLieuxResponse[]
  page?: PageResponseEtatDesLieux
}

export enum TutorialCategory {
  ADMIN = 'ADMIN',
  DEMANDE = 'DEMANDE',
  EDL = 'EDL',
  CONTROLE_QUALITE = 'CONTROLE_QUALITE',
}

export interface IncidentsStatistiquesResponse {
  incidentOuvertAujourdhui?: number
  incidentNonResolu?: number
  incidentCree?: number
  incidentSuivi?: number
  delaiInterventionMinute?: number
  enCoursPrestation?: number
  enCoursInfrastructure?: number
  creePrestation?: number
  creeInfrastructure?: number
  enAttente?: number
  enCours?: number
  enAttenteDeValidation?: number
  totalDeclaration?: number
}

export interface SocieteListResponse {
  societes: SocieteResponse[]
  page: PageResponseSociete
}

export interface TokenPushDeleteRequest {
  tokenPush?: string
}

export interface PlanViewer {
  path: string
  params?: PlanViewerParams
}

export interface PageResponseRoles {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export enum TypeUtilisateur {
  VIPARIS = 'VIPARIS',
  PRESTATAIRE = 'PRESTATAIRE',
  ORGANISATEUR = 'ORGANISATEUR',
  EXPOSANT = 'EXPOSANT',
}

export interface UsersBasicList {
  users: UserBasicResponse[]
}

export interface IncidentResponse {
  /** @format uuid */
  id: string
  libelle: string

  /** @format int64 */
  numero: number

  /** @format uuid */
  utilisateurDeclarantId: string

  /** @format uuid */
  technicienAffecteId?: string

  /** @format uuid */
  siteId: string

  /** @format uuid */
  manifestationId?: string

  /** @format uuid */
  localisationId?: string
  isInfrastructure?: boolean
  remonteDansEtatDesLieux: boolean

  /** @format uuid */
  famillePrestationId?: string

  /** @format uuid */
  societePrestataireId?: string
  isValidePrestataire?: boolean
  quantite: number
  isPrioritaire: boolean
  photoIds: string[]
  status: EtatWorkflowIncidentEnum

  /** @format date-time */
  dateDeCreation: string

  /** @format date-time */
  datePriseEnCharge?: string

  /** @format date-time */
  dateResolution?: string

  /** @format date-time */
  dateCloturePrestataire?: string

  /** @format double */
  tarif?: number
  contactAssocie?: ContactIncident
  commandeAssociee?: CommandeIncident
  plan?: PositionPlanIncident
}

export interface ControleQualiteQuestionResponse {
  /** @format uuid */
  id: string

  /** @format uuid */
  metierId: string
  theme: string
  libelle: string
  description: string
}

export interface PieceJointeCommentaireRequest {
  filename: string

  /** Le contenu de la pièce jointe au format RFC 2397 */
  fileContent: string
}

export interface PlanCreate {
  /** Parametrages d'affichage initial du plan. */
  viewerParams?: PlanViewerParams | null

  /** Le DXF encodé base 64 */
  dxfBase64: string
}

export interface IncidentHistoryListResponse {
  historique: IncidentHistoryResponse[]
}

export interface ControleQualiteReponseResponse {
  /** @format uuid */
  id: string

  /** @format uuid */
  questionId: string

  /** @format uuid */
  localisationId: string
  conformite: ControleQualiteConformite
  commentaire?: string
}

export interface PositionPlanIncident {
  x: string
  y: string
}

export interface ChefProjetManifestationResponse {
  code: string
  nom: string
  prenom: string
  telephone?: string
  email: string
}

export interface TutorialResponse {
  category: TutorialCategory
  platform: TutorialPlatform
  url: string
  title: string
}

export interface ControleQualiteListResponse {
  controles: ControleQualiteResponse[]
  page: ControleQualitePageResponse
}

export interface LocatairePermanentListResponse {
  locatairesPermanent: LocatairePermanentResponse[]
  page: PageResponseLocatairePermanent
}

export interface ControleQualiteMetierResponse {
  /** @format uuid */
  id: string
  libelle: string
  code: string
  societeIds: string[]
}

export interface LoginRefreshRequest {
  refresh_token: string
}

export type LoginSuccessResponse = LoginSuccessBaseResponse & { refresh_token: string }

export type ManifestationDetailResponse = ManifestationResponse & {
  chefProjetManifestation: ChefProjetManifestationResponse[]
}

/**
 * Changement d'état par un utilisateur pour un incident
 */
export interface IncidentHistoryResponse {
  /** @format uuid */
  id: string

  /** @format uuid */
  incidentId: string

  /** @format uuid */
  utilisateurId?: string
  from?: EtatWorkflowIncidentEnum
  to: EtatWorkflowIncidentEnum

  /** @format date-time */
  dateChangementDeStatus: string
}

export interface TutorialListResponse {
  tutorials: TutorialResponse[]
}

export interface ScopesList {
  scopes: string[]
}

export interface AddCommentIncidentRequest {
  commentaire?: string
  commentaireType: CommentaireType
}

export interface CommentaireListResponse {
  commentaireList: CommentaireResponse[]
  page: PageResponseIncident
}

export interface ContactIncident {
  nom: string
  prenom: string
  email: string
  telephone: string
}

export interface SiteListResponse {
  sites: SiteResponse[]
  page: PageResponseSite
}

export interface EtatDesLieuxIncidentFiltreRequest {
  /** Liste des id espaces liés à l'edl */
  espaceIds: string[]

  /** Edl d'entrée ou de sortie */
  typeEtatDesLieux: EtatDesLieuxTypeEnum

  /** @format uuid */
  manifestationId?: string

  /** @format uuid */
  locatairePermanentId?: string
}

export interface PageResponseLocatairePermanent {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export interface FileDetailResponse {
  /** @format uuid */
  id: string
  filename: string
  mimeType: string
  url: string
  fileType: 'IMAGE' | 'PDF' | 'PLAN_DXF' | 'PLAN_GEOJSON'
}

export interface IncidentTokenResponse {
  token: string
  incidentIds: string[]
}

export interface LocalLocatairePermanentResponse {
  libelle: string
  dateDebutOccupation: string
  dateFinOccupation: string
  ville?: string

  /** @format uuid */
  localisationId: string
}

export interface FamilleResponse {
  /** @format uuid */
  id: string

  /** @format uuid */
  siteId: string

  /** @format uuid */
  parentIdFamille?: string
  code: string
  libelle: string
  isInfrastructure: boolean
  isRemiseEnEtat: boolean
  enabled?: boolean
  autoAffectationSocieteIdList: string[]
}

export interface CommentaireResponse {
  /** @format uuid */
  id: string

  /** @format uuid */
  incidentId: string
  commentaire?: string

  /** @format uuid */
  utilisateurId: string
  commentaireType: CommentaireType

  /** @format date-time */
  creationDate: string
  pieceJointeIds: string[]

  /** @format uuid */
  prestataireId?: string

  /** @format uuid */
  nouveauPrestataireId?: string
}

export interface TraitementDevisIncidentRequest {
  action: 'ACCEPTE' | 'REFUSE' | 'ABANDON'
}

export interface EtatDesLieuxPDFRequest {
  etatDesLieuxIds: string[]
}

export interface PageResponseSociete {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export interface PreferenceNotificationListResponse {
  preferenceNotificationList?: PreferenceNotificationResponse[]
  page?: PageResponsePreferenceNotification
}

export interface CommandeResponse {
  /** @format uuid */
  manifestationId: string

  /** @format uuid */
  sousFamilleId?: string
  espace: string
  allee: string
  stand: string
  enseigne: string
  numeroCommande: string
  numeroLigne: string
  nomContact: string
  emailContact: string
  telephoneContact?: string
  libelleFamille?: string
  libelleSousFamille?: string
  libelleArticle: string
  quantite: string
  incidentIdList: string[]
  isCommandeOrganisateur: boolean
}

export interface ControleQualiteBasicMetierResponse {
  /** @format uuid */
  id: string
  libelle: string
}

export enum TypeUtilisateurRole {
  VIPARIS = 'VIPARIS',
  PRESTATAIRE = 'PRESTATAIRE',
  ORGANISATEUR = 'ORGANISATEUR',
  EXPOSANT = 'EXPOSANT',
}

export interface PreferenceNotificationListRequest {
  preferenceNotificationList?: PreferenceNotificationRequest[]
}

export enum TutorialPlatform {
  ALL = 'ALL',
  WEB = 'WEB',
  MOBILE = 'MOBILE',
}

/**
* Droits spécifiques des rôles de l'utilisateur
Note: certains droits dépendent du type d'utilisateur et ne sont pas reflétés dans les scopes
*/
export enum AuthScope {
  SitesTousLecture = 'sites:tous:lecture',
  SitesUtilisateurLecture = 'sites:utilisateur:lecture',
  FiltresUtilisateursDeclarant = 'filtres:utilisateurs:declarant',
  FiltresUtilisateursSociete = 'filtres:utilisateurs:societe',
  FiltresSocietesLecture = 'filtres:societes:lecture',
  ManifestationsLecture = 'manifestations:lecture',
  ManifestationsTousLecture = 'manifestations:tous:lecture',
  ManifestationsUtilisateurLecture = 'manifestations:utilisateur:lecture',
  ManifestationsExposantLecture = 'manifestations:exposant:lecture',
  LocatairesPermanentsLecture = 'locataires-permanents:lecture',
  BandeauPenseBeteLecture = 'bandeau-pense-bete:lecture',
  BandeauPenseBeteValidationLecture = 'bandeau-pense-bete:validation:lecture',
  BandeauPenseBeteEdlLecture = 'bandeau-pense-bete:edl:lecture',
  BandeauPenseBeteChecklistLecture = 'bandeau-pense-bete:checklist:lecture',
  HomePersonaCoordinateur = 'home:persona-coordinateur',
  HomePersonaHotline = 'home:persona-hotline',
  HomePersonaPrestataire = 'home:persona-prestataire',
  HomePersonaOrganisateur = 'home:persona-organisateur',
  HomePersonaExposant = 'home:persona-exposant',
  PrestationsCommandesOrganisateurLectures = 'prestations:commandes-organisateur:lectures',
  PrestationsCommandesExposantLectures = 'prestations:commandes-exposant:lectures',
  DemandesSiteLecture = 'demandes:site:lecture',
  DemandesManifestationLecture = 'demandes:manifestation:lecture',
  DemandesSocieteLecture = 'demandes:societe:lecture',
  DemandesTiersLecture = 'demandes:tiers:lecture',
  DemandesRemiseEnEtatLecture = 'demandes:remise-en-etat:lecture',
  DemandesIncidentLecture = 'demandes:incident:lecture',
  DemandesPrestationLecture = 'demandes:prestation:lecture',
  DemandesRemiseEnEtatCreation = 'demandes:remise-en-etat:creation',
  DemandesPasserValisationCreation = 'demandes:passer-valisation:creation',
  DemandesIncidentCreation = 'demandes:incident:creation',
  DemandeCommentaireCreation = 'demande:commentaire:creation',
  DemandesPrestationOrganisateurCreation = 'demandes:prestation-organisateur:creation',
  DemandesPrestationExposantCreation = 'demandes:prestation-exposant:creation',
  DemandesPrioritaireCreation = 'demandes:prioritaire:creation',
  DemandesRemonteEtatDesLieuxCreation = 'demandes:remonte-etat-des-lieux:creation',
  DemandesDevisCreation = 'demandes:devis:creation',
  DemandesHorsManifestationCreation = 'demandes:hors-manifestation:creation',
  DemandesContactCreation = 'demandes:contact:creation',
  DemandesPlanLecture = 'demandes:plan:lecture',
  DemandesTarifLecture = 'demandes:tarif:lecture',
  DemandesWorkflowValidation = 'demandes:workflow:validation',
  DemandesWorkflowEnvoiDevis = 'demandes:workflow:envoi-devis',
  DemandesWorkflowTraitementDevis = 'demandes:workflow:traitement-devis',
  DemandesWorkflowAccepter = 'demandes:workflow:accepter',
  DemandesWorkflowRefuser = 'demandes:workflow:refuser',
  DemandesWorkflowPriseEnCharge = 'demandes:workflow:prise-en-charge',
  DemandesWorkflowMiseEnPause = 'demandes:workflow:mise-en-pause',
  DemandesWorkflowFermeturePrestataire = 'demandes:workflow:fermeture-prestataire',
  DemandesWorkflowFermetureViparis = 'demandes:workflow:fermeture-viparis',
  DemandesWorkflowReouverture = 'demandes:workflow:reouverture',
  DemandesWorkflowAbandon = 'demandes:workflow:abandon',
  DemandesPrestataireAffectation = 'demandes:prestataire:affectation',
  DemandesTechnicienAffectation = 'demandes:technicien:affectation',
  DemandesSuiviCreation = 'demandes:suivi:creation',
  StatistiquesSiteLecture = 'statistiques:site:lecture',
  StatistiquesManifestationLecture = 'statistiques:manifestation:lecture',
  CheckListSiteLecture = 'check-list:site:lecture',
  CheckListSiteCreation = 'check-list:site:creation',
  CheckListSiteCloture = 'check-list:site:cloture',
  CheckListReponseDelegation = 'check-list:reponse:delegation',
  CheckListReponseConformite = 'check-list:reponse:conformite',
  CheckListReponseNonConformite = 'check-list:reponse:non-conformite',
  CheckListReponseExclusion = 'check-list:reponse:exclusion',
  ControleQualiteSiteLecture = 'controle-qualite:site:lecture',
  ControleQualitePrestataireLecture = 'controle-qualite:prestataire:lecture',
  ControleQualiteSiteCreation = 'controle-qualite:site:creation',
  ControleQualiteSiteSuppression = 'controle-qualite:site:suppression',
  ControleQualitePrestataireCreation = 'controle-qualite:prestataire:creation',
  UtilisateursSignatureModification = 'utilisateurs:signature:modification',
  UtilisateursInformationModification = 'utilisateurs:information:modification',
  ExportDemandesXlsx = 'export:demandes:xlsx',
  ExportDemandesPdf = 'export:demandes:pdf',
  AdminUtilisateursTous = 'admin:utilisateurs:tous',
  AdminUtilisateursManifestation = 'admin:utilisateurs:manifestation',
  AdminUtilisateursSociete = 'admin:utilisateurs:societe',
  AdminUtilisateursToutesManifestation = 'admin:utilisateurs:toutes-manifestation',
  AdminUtilisateursToutesSociete = 'admin:utilisateurs:toutes-societe',
  AdminUtilisateursCreationTous = 'admin:utilisateurs:creation-tous',
  AdminUtilisateursCreationOrganisateur = 'admin:utilisateurs:creation-organisateur',
  AdminUtilisateursCreationPrestataire = 'admin:utilisateurs:creation-prestataire',
  AdminTacheLancementManuel = 'admin:tache:lancement_manuel',
  AdminPlanCreation = 'admin:plan:creation',
  AdminRoleEdition = 'admin:role:edition',
  EdlSiteLecture = 'edl:site:lecture',
  EdlEntreeCreation = 'edl:entree:creation',
  EdlSortieCreation = 'edl:sortie:creation',
  EdlCreationSignature = 'edl:creation:signature',
  EdlTelechargementLecture = 'edl:telechargement:lecture',
  EdlSetCommandeMagicRenvoi = 'edl:set_commande_magic:renvoi',
  NotificationChefEquipePrestataire = 'notification:chef_equipe_prestataire',
  VideoViparisLecture = 'video:viparis:lecture',
  VideoPrestataireLecture = 'video:prestataire:lecture',
  VideoAdminLecture = 'video:admin:lecture',
}

export enum CommentaireType {
  COMMENTAIRE = 'COMMENTAIRE',
  RELANCE_PRESTATAIRE = 'RELANCE_PRESTATAIRE',
  REFUS_MAUVAIS_PRESTATAIRE = 'REFUS_MAUVAIS_PRESTATAIRE',
  REFUS_PRESTATAIRE = 'REFUS_PRESTATAIRE',
  REAFFECTATION_PRESTATAIRE = 'REAFFECTATION_PRESTATAIRE',
  DEVIS = 'DEVIS',
  STAND_INACCESSIBLE = 'STAND_INACCESSIBLE',
}

export interface ManifestationSearchResponse {
  manifestations: ManifestationResponse[]
  page: PageResponseManifestation
}

export interface ControleQualiteBasicSocieteListResponse {
  societes: ControleQualiteBasicSocieteResponse[]
  page: ControleQualitePageResponse
}

export interface PreferenceNotificationResponse {
  /** @format uuid */
  siteId?: string
  typeCanal?: TypeCanalEnum
  typeEvenement?: TypeEvenementEnum
  typeIncident?: TypeIncidentEnum
}

export interface ControleQualiteMetierListResponse {
  metiers: ControleQualiteMetierResponse[]
}

export interface PlansResponse {
  plans: Plan[]
  page: PageResponsePlan
}

export interface ControleQualitePageResponse {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export enum TypeEvenementEnum {
  OUVERTURE_INCIDENT = 'OUVERTURE_INCIDENT',
  CHANGEMENT_ETAT_INCIDENT = 'CHANGEMENT_ETAT_INCIDENT',
  FERMETURE_INCIDENT = 'FERMETURE_INCIDENT',
  AJOUT_COMMENTAIRE = 'AJOUT_COMMENTAIRE',
}

export interface PlanViewerParamsCenter {
  x: number
  y: number
}

export interface LoginRequest {
  login: string
  password: string
}

export interface EtatDesLieuxResponse {
  /** @format uuid */
  id: string

  /** @format uuid */
  utilisateurInitiateurId: string
  commentaire?: string

  /** Liste des id incident accepté liés à cet edl */
  incidentAccepteIds: string[]

  /** Liste des id incident refusé liés à cet edl */
  incidentRefuseIds: string[]

  /**
   * Id de la manifestation
   * @format uuid
   */
  manifestationId?: string

  /**
   * Id du locataire permanent
   * @format uuid
   */
  locatairePermanentId?: string

  /** Edl d'entrée ou de sortie */
  type: EtatDesLieuxTypeEnum

  /**
   * Date de la clôture de l'edl
   * @format date-time
   */
  dateDeValidation: string

  /** Liste des id espaces liés à l'edl */
  espaceIds: string[]
  envoieCommandeMagic: boolean

  /** @format uuid */
  signatureViparisFileId?: string

  /** Infos des personnes qui ont signées l'edl */
  contactOrganisateur: ContactOrganisateurResponse
}

export interface RoleCreationRequest {
  name: string
  typeUtilisateur: TypeUtilisateurRole
  scopes: string[]
}

export interface ReaffectationIncidentRequest {
  /** @format uuid */
  societePrestataireId: string
}

export interface PageResponseManifestation {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export enum ControleQualiteNature {
  PRESTATION = 'PRESTATION',
  MAINTENANCE = 'MAINTENANCE',
}

export interface PageResponseLocalisation {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export interface LocatairePermanentResponse {
  /** @format uuid */
  id: string

  /** @format uuid */
  siteId: string
  nomLocatairePermanent: string
  idTiers: string
  locaux: LocalLocatairePermanentResponse[]
}

export interface ControleQualiteBasicManifestationListResponse {
  manifestations: ControleQualiteBasicManifestationResponse[]
  page: ControleQualitePageResponse
}

export enum TypeIncidentEnum {
  SUIVI = 'SUIVI',
  CREE = 'CREE',
  TOUTE = 'TOUTE',
}

export enum TypeCanalEnum {
  PUSH = 'PUSH',
  SMS = 'SMS',
  MAIL = 'MAIL',
}

export interface ControleQualiteBasicMetierListResponse {
  metiers: ControleQualiteBasicMetierResponse[]
  page: ControleQualitePageResponse
}

export interface CreationUserRequest {
  /** trigramme identifiant les utilisateurs Viparis dans Magic (uniquement pour les utilisateurs type Viparis) */
  codeMagic?: string
  nom: string
  prenom: string
  email: string
  numeroTelephonePortable: string
  fonction: string

  /** @format uuid */
  societeId?: string
  langage: Langage
  typeUtilisateur: TypeUtilisateur

  /** Manifestations auxquelles ratacher un organisateur */
  manifestationIds: string[]

  /** Sites auxquelles ratacher un utilisateur viparis */
  siteIds: string[]

  /** Roles associés a l'utilisateur */
  roleIds: string[]
  enabled?: boolean
}

export enum ControleQualiteIntervalleHistorique {
  SEMAINE = 'SEMAINE',
  MOIS = 'MOIS',
}

export interface AcceptIncidentRequest {
  accept: boolean
  isMauvaisPrestataire?: boolean
  commentaire?: string

  /** @format uuid */
  utilisateurId?: string
}

export interface SsoToken {
  token?: string
}

export interface PageResponseContacts {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export interface IncidentsListResponse {
  incidents: IncidentResponse[]
  page: PageResponseIncident
}

export interface ControleQualiteHistoriqueResponse {
  /** @format double */
  tauxConformiteMoyen: number

  /** @format date */
  date: string
}

export interface RoleUpdateRequest {
  /** @format uuid */
  id: string
  scopes: string[]
}

export interface LoginSuccessBaseResponse {
  access_token: string
  expires_in: number
  scopes: AuthScope[]
}

export interface Contact {
  /** @format uuid */
  id: string

  /** @format email */
  email: string
  nom?: string
  prenom?: string
}

export type UserResponse = UserBasicResponse & {
  codeMagic?: string
  email: string
  numeroTelephonePortable: string
  fonction: string
  societeId: string
  chefEquipe?: boolean
  signatureFileId?: string
  langage?: Langage
  typeUtilisateur: TypeUtilisateur
  manifestationIds: string[]
  siteIds: string[]
  roleIds: string[]
  enabled: boolean
  creationDate: string
  modificationDate: string
  modificationUser?: string
}

/**
 * Infos des personnes qui ont signées l'edl
 */
export interface ContactOrganisateurResponse {
  nom: string
  prenom: string
  email: string

  /** @format uuid */
  signatureFileId: string
}

export interface IncidentFilterRequest {
  /** @format date-time */
  dateDebut?: string

  /** @format date-time */
  dateFin?: string

  /** @format uuid */
  siteId?: string

  /** @format uuid */
  manifestationId?: string

  /** @format uuid */
  localisationId?: string
  incidentIds?: string[]
  siteIds?: string[]
  manifestationIds?: string[]
  familleIds?: string[]
  utilisateurIds?: string[]
  societeIds?: string[]
  etatsIncident?: EtatWorkflowIncidentEnum[]
  typeIncident?: 'TOUS' | 'INFRASTUCTURE' | 'MANIFESTATION'
  infrastructure?: boolean
  localisationIds?: string[]
  cree?: boolean
  suivie?: boolean

  /** Créée lors des dernières 24 heures */
  recente?: boolean
  prioritaire?: boolean

  /** Possèdes des positions x & y qui permettent de l'afficher sur un plan */
  plan?: boolean

  /** Recherche textuelle - numéro de l'incident, libellé de la famille OU sous-famille OU sous-sous-famille, libellé de la manifestation, nom de la société prestataire attribuée, enseigne de la commande associée, type de demande */
  recherche?: string
}

export interface IncidentBasicSocieteResponse {
  /** @format uuid */
  id: string
  libelle: string
}

export interface EtatDesLieuxCreationRequest {
  token: string
  commentaire?: string

  /** Liste des id incident accepté liés à cet edl */
  incidentAccepteIds: string[]

  /** Liste des id incident refusés liés à cet edl */
  incidentRefuseIds: string[]

  /** @format uuid */
  locatairePermanentId?: string

  /** @format uuid */
  manifestationId?: string

  /** Edl d'entrée ou de sortie */
  type: EtatDesLieuxTypeEnum

  /** Liste des id espaces liés à l'edl */
  espaceIds: string[]

  /** @format base64 */
  signatureViparisBase64?: string

  /** Infos des personnes qui ont signées l'edl */
  contactOrganisateur?: ContactOrganisateurRequest

  /** @format uuid */
  siteId?: string

  /** Liste des contacts supplémentaires liés à l'edl */
  contacts?: ContactEtatDesLieux[]
}

export interface SiteResponse {
  /** @format uuid */
  id: string
  codeLieu: string
  commentaireParDefautEDLSortie?: string
  notificationParDefautCommentaireOrganisateur?: string
  activationCommentairesOrganisateur: boolean
}

export interface CommandeNonConnecteResponse {
  /** @format uuid */
  manifestationId: string

  /** @format uuid */
  sousFamilleId: string
  allee?: string
  stand?: string
  espace: string
  enseigne: string
  libelleFamille: string
  libelleSousFamille: string
  libelleArticle: string
  nombreIncidentOuvert: number
}

export interface SignatureRequest {
  /** @format base64 */
  signatureBase64: string

  /** @format string */
  filename: string
}

export interface PageResponseUsers {
  pageNumber: number
  pageSize: number
  totalPage: number

  /** @format int64 */
  totalElement: number
}

export interface TokenPushRequest {
  tokenPush?: string
  plateforme?: 'IOS' | 'ANDROID'
}
